import styled from "@emotion/styled";

/**
 * Shared uppercase section header for the refill hub — the single source of truth for
 * "Your requirements" (over the hero), "Your pharmacy" and "Related materials" (over the
 * light body), so the three can't drift. Figma "Body/Table header": STK Bureau Sans Medium,
 * 12px, 0.04em tracking, line-height 1.4.
 *
 * Rendered as an `h3` (section heading), so `font-family`/`font-weight`/`font-size` are set
 * explicitly to override the global serif h3 rule. Defaults to charcoal-60 (the section
 * headers on the light body); pass `$onDark` for the white variant over the hero photo.
 *
 * The 4px left inset is intentional (Figma "Table Header Row" pl-4): headers sit a hair
 * inside the 24px content column that the cards/bars/grid align flush to.
 */
const HubSectionLabel = styled("h3", {
  shouldForwardProp: (prop) => prop !== "$onDark"
})<{ $onDark?: boolean }>`
  margin: 0;
  padding-left: 4px;
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.4;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ $onDark }) =>
    $onDark ? "var(--color-white)" : "var(--color-charcoal-60)"};
`;

export default HubSectionLabel;
